import React, { PureComponent } from 'react';
import {
    Typography,
    ExpansionPanel,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
} from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons';
// import COLORS from 'shared/colors';

const classes = {
    item: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '89%',
    }
}

class Overview extends PureComponent {
    render() {
        const { 
          rawPropCount,
          propCount,
          rawPropCountPipeline,
          propCountPipeline,subCount,
          riskCount,
          // totalSubUnitsPipeline 
        } = this.props

        let text = '';
        const noResults = 'No results. Please try a different query.';
        const resultsHead = 'Displaying '
        const resultsTail = ' from the database.'
        // const resultsExsiting = (propCount  !== rawPropCount) ? 
        //                         `${propCount} (out of ${rawPropCount} total) existing properties`
        //                         : `all ${propCount} existing properties`
        const resultsExsiting = (propCount  !== rawPropCount) ? 
                                `${propCount} (out of ${rawPropCount} total) properties`
                                : `all ${propCount} existing properties`
        // const resultsPipeline = (propCountPipeline  !== rawPropCountPipeline)?
        //                         ` and ${propCountPipeline} (out of ${rawPropCountPipeline} total) pipeline properties`
        //                         : ` and all ${propCountPipeline} pipeline properties`
        // const results = resultsHead + resultsExsiting + resultsPipeline + resultsTail
        const results = resultsHead + resultsExsiting  + resultsTail

        // const initial = `Displaying all ${propCount} existing properties  and all ${propCountPipeline} pipeline properties from the database.`
        const initial = `Displaying all ${propCount} properties from the database.`

        if (propCount  !== rawPropCount || propCountPipeline  !== rawPropCountPipeline) {
            text = (!propCount && !propCountPipeline) ? noResults : results;
        } else {
            text = initial;
        }

        return (
            propCount !== undefined ? (
                <div className="overview" style={{ width: '400px' }}>
                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMore />}
                        >
                            <Typography>{text}</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <div style={{ width: '100%' }}>
                            {/* <div style={classes.item}>
                                    <Typography variant="h6" style={{ color: 'rgb(216, 34, 56)' }}>
                                        Existing Projects
                                    </Typography>
                                </div> */}
                                <div style={classes.item}>
                                    <Typography variant="body2">
                                        Number of subsidized units:
                                    </Typography>
                                    <Typography variant="body2">
                                        {(subCount || 0).toLocaleString()}
                                    </Typography>
                                </div>
                                <div style={classes.item}>
                                    <Typography variant="body2">
                                        At-risk units (expiring within 6 mo):
                                    </Typography>
                                    <Typography variant="body2">
                                        {(riskCount || 0).toLocaleString()}
                                    </Typography>
                                </div>
                            </div>
                        </ExpansionPanelDetails>
                        {/* <ExpansionPanelDetails>
                            <div style={{ width: '100%' }}>
                            <div style={classes.item}>
                                    <Typography variant="h6" style={{ color: 'rgb(115, 173, 150)' }}>
                                        Pipeline Projects
                                    </Typography>
                                </div>
                                <div style={classes.item}>
                                    <Typography variant="body2">
                                        Number of subsidized units:
                                    </Typography>
                                    <Typography variant="body2">
                                        {(totalSubUnitsPipeline || 0).toLocaleString()}
                                    </Typography>
                                </div>
            
                            </div>
                        </ExpansionPanelDetails> */}
                    </ExpansionPanel>
                </div>
            ) : null
        )
    }
}

export default Overview